/* eslint-disable no-restricted-imports */
import type { SingleGameFragment } from '~/client/components/Game/graphql/SingleGameFragment.generated';
import Translate from '~/client/shared/i18n/Translate';
import MobileGameDetailsRow from '..';

type Props = Pick<SingleGameFragment, 'inLoyalty'>;

const InLoyaltyRow: FC<Props> = ({ inLoyalty }) => (
  <MobileGameDetailsRow translateId="loyalty.loyalty_system">
    <Translate id={inLoyalty ? 'casino.included' : 'casino.not_included'} />
  </MobileGameDetailsRow>
);

export default InLoyaltyRow;
